module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-L-33.aab6cddd.png";